import * as React from 'react';
import { UserMenuContext } from './UserMenuContext';
/**
 * A React context provider that provides access to the user menu context.
 * @param props
 * @param {ReactNode} props.children
 * @param {UserMenuContextValue} props.value The user menu context
 */
export var UserMenuContextProvider = function (_a) {
    var children = _a.children, value = _a.value;
    return (React.createElement(UserMenuContext.Provider, { value: value }, children));
};
//# sourceMappingURL=UserMenuContextProvider.js.map